var map = {
	"./aliyun.logo-l.png": 400,
	"./baidu.logo-l.png": 401,
	"./chuanglan.logo-l.png": 402,
	"./emay.logo-l.png": 403,
	"./guodu.logo-l.png": 404,
	"./huawei.logo-l.png": 405,
	"./jiguang.logo-l.png": 406,
	"./juhe.logo-l.png": 407,
	"./montnets-g.logo-l.png": 408,
	"./submail.logo-l.png": 409,
	"./tencent.logo-l.png": 410,
	"./yunpian.logo-l.png": 411,
	"./zhutong.logo-l.png": 412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 399;